var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownloadingUploading = function SvgDownloadingUploading(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_36658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.46549 26.127C7.46549 25.4355 7.3272 24.6058 7.74207 23.9143C8.43352 22.5314 10.093 22.1166 11.6142 21.9783C28.209 20.7337 39.6871 20.4571 56.0054 19.7656C56.9734 19.7656 57.9414 19.7656 58.6329 20.3188C59.7392 21.1485 60.0158 22.6697 60.1541 24.0526C61.2604 34.701 63.0582 45.4876 63.473 56.136C63.6113 58.3486 62.6433 59.7315 61.6753 59.8698C52.2715 61.5293 41.8998 61.6676 32.3577 62.2207C28.3473 62.4973 13.2737 63.7419 11.061 62.6356C9.40155 61.6676 9.40155 58.072 9.26326 56.6891C8.29523 46.7322 8.01865 36.3605 7.46549 26.127Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5922 56.9653C36.0919 56.4122 45.219 55.9973 57.5269 54.7527C56.8354 45.2107 55.8674 34.8389 54.7611 25.2969C41.4852 25.9883 30.422 26.1266 13.8271 27.3712C13.8271 31.3816 13.9654 36.9133 14.242 41.8917C14.6569 47.9765 14.7952 52.2635 15.2101 56.827C15.3483 58.7631 26.4116 57.1036 29.5922 56.9653Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9336 50.3269C18.944 46.8697 22.9544 43.5507 27.1031 40.0935C28.0712 39.402 29.0392 38.5723 30.2838 38.7106C30.6987 38.8488 30.9753 38.9871 31.3901 39.1254C33.0496 39.9552 36.092 42.721 38.0281 42.5827C40.379 42.4444 41.4853 39.402 44.1128 39.6786C45.0809 39.8169 46.0489 40.2318 47.0169 40.7849C50.1976 42.4444 53.3783 44.1039 56.559 45.9017",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6984 30.5523C42.1772 31.9352 42.3155 34.8393 44.5282 35.8073C46.3259 36.4987 48.5386 35.2541 48.6769 33.3181C48.8151 31.7969 47.7088 30.1374 46.1876 29.9991C45.4962 29.8608 44.2516 29.9991 43.6984 30.5523Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.124 41.6152C37.6132 43.413 39.8259 43.8279 41.9002 44.9342",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5053 34.7012C64.4414 34.8395 66.2391 34.8395 68.7284 35.116C71.0793 35.3926 74.1217 35.2543 75.9195 37.0521C76.7492 38.0201 76.8875 39.403 76.7492 40.6477C76.4726 47.2856 75.7812 53.7852 75.7812 60.4232C75.7812 62.6358 75.6429 64.0187 75.3663 66.3696C75.0897 69.2737 72.8771 70.2418 67.7603 69.8269C52.5484 68.9972 42.5915 68.444 28.7625 66.9228C26.9647 66.6462 25.9967 65.5399 25.8584 63.7421",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4648 62.4964C44.8046 63.3262 61.1229 64.7091 67.8991 64.8474C68.4523 64.8474 69.0054 64.8474 69.5586 64.4325C70.25 64.0176 70.3883 63.0496 70.3883 62.3581C70.8032 55.8585 71.0798 47.8377 71.3564 41.338C71.3564 41.0614 71.3564 40.7849 71.2181 40.5083C71.0798 40.2317 70.6649 40.2317 70.3883 40.0934C67.4842 39.6785 64.1653 39.5403 62.3675 39.2637",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6885 64.5717C34.571 63.7419 39.4112 63.3271 49.2298 61.5293",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4839 11.6055C67.4839 11.6055 66.5159 14.0947 65.5479 16.169",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9837 17.6914C72.4625 18.936 69.835 21.0104 69.835 21.0104",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8874 26.6797C75.5045 26.6797 74.2599 26.818 72.877 26.818",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_36658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.1875,
    height: 60.8477,
    fill: "white",
    transform: "translate(6.08301 10.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadingUploading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "downloading-uploading.6f33025681e1cc87329038f5e5204104.svg";